import { render, staticRenderFns } from "./EmailSignatarioNovo.vue?vue&type=template&id=02b98d54"
import script from "./EmailSignatarioNovo.vue?vue&type=script&lang=js"
export * from "./EmailSignatarioNovo.vue?vue&type=script&lang=js"
import style0 from "./EmailSignatarioNovo.vue?vue&type=style&index=0&id=02b98d54&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports